import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed the video playback speed',
  name: 'changed_video_playback_rate',
  params: [
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
    {
      description: 'The new playback speed',
      name: 'speed',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
